
import React, { useState, useEffect } from 'react';
import Chart from "react-google-charts";
import { useSelector, useDispatch } from "react-redux";
import { getCalculations } from '../../../../../../common/policyCalculation';
import { pathOr } from "ramda";


const GeoChart = ({ data,value,fullData }) => {
    // const classes = useStyles();
   const result= pathOr([], ['result'],fullData );
   const callbackMethod= pathOr([], ['data','callbackMethod'],data );
   const resultData = [
        ['Region Code', 'Continent', 'Popularity'],
        ['142', 'Asia', 0],
        ['150', 'Europe', 900],
        ['021', 'Northern America', 300],
        ['013', 'Central America', 300],
        ['005', 'South America', 900],
        ['009', 'Oceania', 300],
        ['002', 'Africa', 300]
    ]
    
    //getCalculations(callbackMethod, result);
//   console.log("geodata",resultData,[
//     ['Region Code', 'Continent', 'Popularity'],
//     ['142', 'Asia', 0],
//     ['150', 'Europe', 900],
//     ['021', 'Northern America', 300],
//     ['013', 'Central America', 300],
//     ['005', 'South America', 900],
//     ['009', 'Oceania', 300],
//     ['002', 'Africa', 300]
// ])
    return (
        <>
            <Chart
                // width={"500px"}
                height={"280px"}
                chartType="GeoChart"
                data={resultData}//{[resultData]}
                   options = {{
                    // displayMode: 'markers',
                    resolution: 'subcontinents',
                    // region: '002', // Africa
                    colorAxis: {colors: ['#00853f', 'black', '#e31b23']},
                    // backgroundColor: '#81d4fa',
                    // datalessRegionColor: '#f8bbd0',
                    // defaultColor: '#f5f5f5',
                    sizeAxis: { minValue: 0, maxValue: 100 },
              
                  }}
                // Note: you will need to get a mapsApiKey for your project.
                // See: https://developers.google.com/chart/interactive/docs/basic_load_libs#load-settings
                mapsApiKey="AIzaSyD-9tSrke72PouQMnMX-a7eZSW0jkFMBWY"
                rootProps={{ 'data-testid': '1' }}
            />           
        </>
    );

}

export default GeoChart;